<template>
	<div v-if="news" class="alert alert-secondary my-3 mx-2 mx-lg-0" role="alert" id="news-box">
		<!--<h3 class="mb-4 text-center">NEWS</h3>-->
    <div v-for="(newsItem, index) in news" :key="index" class="mb-4">
			<h3 v-if="newsItem.title" class="mb-3">NEWS: {{ newsItem.title }}</h3>
			
			<span v-if="showReadMore && !arrReadMoreActivated[index] && arrShowMore[index]">{{ getCleanText(newsItem.text) }}</span>
			<a class="ms-2" v-if="showReadMore && !arrReadMoreActivated[index] && arrShowMore[index]" @click="activateReadMore(index)" href="#">Read more</a>
			
			<div v-if="!showReadMore || arrReadMoreActivated[index] || !arrShowMore[index]" v-html="newsItem.text"></div>
			<div class="text-center" v-if="showReadMore && (arrReadMoreActivated[index] && arrShowMore[index])"><a @click="deactivateReadMore(index)" href="#">Read less</a></div>
			
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  props: ['news'],
	data() {
		return {
			showReadMore: (window.innerWidth > 992) ? false : true,
			maxStrLen: 65,
			arrShowMore: [],
			arrReadMoreActivated: []
		}
	},
	mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    }),
		this.checkReadMore()
  },
  beforeUnmount() { 
    window.removeEventListener('resize', this.onResize); 
  },
	methods: {
		onResize() {
      this.showReadMore = (window.innerWidth > 992) ? false : true
    },
		checkReadMore() {
			let text = ''
			let that = this
			this.news.forEach(function(obj) {
				let div = document.createElement("div")
				div.innerHTML = obj.text
				text = div.textContent
				if (text.length > that.maxStrLen) {
					that.arrShowMore.push(true)
					that.arrReadMoreActivated.push(false)
				} else {
					that.arrShowMore.push(false)
					that.arrReadMoreActivated.push(true)
				}
			})
		},
		activateReadMore(index) {
			console.log(index +' ReadMoreActivated')
			this.arrReadMoreActivated[index] = true
			//this.readMoreActivated = true;
		},
		deactivateReadMore(index) {
			this.arrReadMoreActivated[index] = false
			//this.readMoreActivated = false;
		},
		getCleanText(html) {
			console.log('width', window.innerWidth)
			let div = document.createElement("div")
			div.innerHTML = html
			let text = div.textContent
			if (text.length > this.maxStrLen) {
				text = text.slice(0, this.maxStrLen) +'...'
			}
			return text
		}
	}
}
</script>

<style>
</style>

<style scoped>
</style>
